import { SelectOption } from 'components/Select'
import { Alert } from 'features/alerts/types/alert'
import { DomainBidder, DomainBidderParameter } from 'features/globalSetup/types/domainBidder'
import { DomainAlerts } from 'features/inventory/domain'
import { DomainAlert } from 'features/inventory/domain/types/DomainAlert'
import { DomainBidderOption } from '../../hooks/useGetDomainBiddersForSelect'

export const getRelatedDomainId = (
  domainBidderId: DomainBidder['id'],
  options: SelectOption<DomainBidderOption>[],
): DomainBidder['id'] => {
  const domainBidder: SelectOption<DomainBidderOption> | undefined = options.find(
    (option: SelectOption<DomainBidderOption>): boolean => option.value === domainBidderId,
  )

  if (domainBidder === undefined || domainBidder.rawData === undefined) {
    throw Error('DomainBidder related IDs should be accessible')
  }

  return domainBidder.rawData.domain.id
}

export const getOptionalParamsCount = (
  domainBidder: Pick<DomainBidder, 'csParamsSchema' | 's2sParamsSchema'>,
): number =>
  [...domainBidder.csParamsSchema, ...domainBidder.s2sParamsSchema].filter(
    (parameter: DomainBidderParameter): boolean => parameter.required === false,
  ).length

export const optionsMapper = (
  options: SelectOption<DomainBidderOption>[],
): SelectOption<DomainBidderOption>[] =>
  options.map((option: SelectOption<DomainBidderOption>): SelectOption<DomainBidderOption> => {
    const abTestAlert: Alert<DomainAlert> | undefined = option.rawData?.domain.alerts.find(
      (alert: Alert<DomainAlert>) => alert.name === 'abTestActive',
    )

    return {
      ...option,
      endAdornment: abTestAlert ? <DomainAlerts alerts={[abTestAlert]} /> : undefined,
    }
  })
